import Proptypes from 'prop-types';

export const CREATE = 'criar';
export const EDIT = 'editar';
export const VIEW = 'visualizar';

export const propType = Proptypes.oneOf([CREATE, EDIT, VIEW]);
